import styled from '@emotion/styled';

export const StyledAction = styled.div`
	display: block;
	margin-bottom: 16px;
`;
